import React from "react";
import "./Arkitekttjänst.css";
import Arkitekttjänstimg from "../../assets/ttgvideo8.mov";

const Arkitekttjänst = () => {
  return (
    <div className="box-2-tak-till-golv-three-main-info-TeamMeeting-1">
      <div className="tak-till-golv-three-text-container-3-custom-TeamMeeting-1">
        <div className="tak-till-golv-three-title-3-custom-TeamMeeting">
          Fullständig Arkitekttjänst för Dina Byggprojekt
        </div>

        <div className="tak-till-golv-three-text-3-custom1-TeamMeeting">
          Vid Tak Till Golv strävar vi efter att erbjuda en heltäckande service
          för våra kunder, och det inkluderar även professionell
          arkitekturkonsultation och design. Vi förstår vikten av att ha en
          genomtänkt och väldesignad plan för ditt byggprojekt, och därför
          samarbetar vi med erfarna och kreativa arkitekter för att skapa unika
          och funktionella lösningar för varje kunds behov.
          <br></br>
          <br></br>
          Våra arkitekter arbetar nära med dig för att förstå dina önskemål och
          behov, och sedan omsätta dem till praktiska och estetiskt tilltalande
          designkoncept. Oavsett om det handlar om att skapa en nybyggnad från
          grunden, renovera ett befintligt utrymme eller helt enkelt förbättra
          dess estetik och funktionalitet, kan våra arkitekter hjälpa till att
          göra din vision till verklighet.
          <br></br>
          <br></br>
          Vi tar hand om hela processen, från den första skissfasen till den
          slutliga godkännandeprocessen, och säkerställer att varje detalj är
          noggrant planerad och utförd enligt högsta standard. Med våra
          professionella arkitekttjänster kan du vara säker på att ditt
          byggprojekt kommer att vara både vackert utformat och väl utfört.
        </div>
      </div>
      <div className="tak-till-golv-three-video-container-right-1-3-custom-TeamMeeting-1">
        <video src={Arkitekttjänstimg} autoPlay loop muted />
      </div>
    </div>
  );
};

export default Arkitekttjänst;
